import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { HowItWorks } from './components/HowItWorks';
import { ValueProposition } from './components/ValueProposition';
import { Pricing } from './components/Pricing';
import { Professionals } from './components/Professionals';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { Quiz } from './components/Quiz';
export function App() {
  const [showQuiz, setShowQuiz] = useState(false);
  const startQuiz = () => {
    setShowQuiz(true);
    window.scrollTo(0, 0);
  };
  if (showQuiz) {
    return <div className="min-h-screen bg-primary font-sans text-text-primary" data-id="element-0">
        <Quiz data-id="element-1" />
      </div>;
  }
  return <div className="min-h-screen bg-primary font-sans text-text-primary selection:bg-accent selection:text-white pb-24 lg:pb-0" data-id="element-2">
      <Navbar onStartQuiz={startQuiz} data-id="element-3" />
      <main data-id="element-4">
        <Hero onStartQuiz={startQuiz} data-id="element-5" />
        <Problem data-id="element-6" />
        <HowItWorks onStartQuiz={startQuiz} data-id="element-7" />
        <ValueProposition data-id="element-8" />
        <Pricing data-id="element-9" />
        <Professionals data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA onStartQuiz={startQuiz} data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyMobileCTA onStartQuiz={startQuiz} data-id="element-15" />
    </div>;
}